module.exports = __webpack_public_path__ + "img/641.88f25057.jpg";